if (!customElements.get('cart-drawer-info-slider')) {
  class CartDrawerInfoSlider extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', (e) => {
          this.init();
        });
      }
      this.init();


    }

    init() {

      var swiperArea = document.querySelector('.cart-drawer__swiper');

      this.slider = new Swiper(swiperArea, {
        direction: 'vertical',
        slidesPerView: 1,
        loop: true,
        allowTouchMove: false,
        autoplay: {
          delay: 5000,
        }
      });
    }
  }

  customElements.define('cart-drawer-info-slider', CartDrawerInfoSlider);
}

if (!customElements.get('cart-empty-recommendations')) {
  class CartEmptyRecommendations extends HTMLElement {
    constructor() {
      super();
      this._swiper = null;
    }

    connectedCallback() {
      // Defer to next frame so the drawer/section has a measured width.
      // This is important when the cart is emptied and the drawer body is
      // re-rendered via innerHTML (Swiper needs a laid-out container).
      this._raf = requestAnimationFrame(() => this.init());
    }

    disconnectedCallback() {
      if (this._raf) cancelAnimationFrame(this._raf);
      if (this._swiper) {
        this._swiper.destroy(true, true);
        this._swiper = null;
      }
    }

    init() {
      if (this._swiper) return;
      const swiperEl = this.querySelector('.cart-drawer__empty-recs-swiper');
      if (!swiperEl || typeof Swiper === 'undefined') return;

      this._swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        grabCursor: true,
        watchOverflow: true,
        simulateTouch: true,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        navigation: {
          prevEl: this.querySelector('.cart-drawer__empty-recs-prev'),
          nextEl: this.querySelector('.cart-drawer__empty-recs-next')
        },
        breakpoints: {
          990: {
            spaceBetween: 16
          }
        }
      });
    }
  }

  customElements.define('cart-empty-recommendations', CartEmptyRecommendations);
}
